import { makeAutoObservable, runInAction } from 'mobx';
import axios from 'axios';

class RootStore {
  // auth
  currentUser = null; // { id, username, role }
  authToken = null;
  authLoading = false;
  authError = null;

  // bx
  bx = []; // 我的申请数据
  bxLoading = false;
  bxError = null;
  pagination = {
    page: 1,
    pageSize: 25,
    total: 0,
    totalPages: 0
  };
  
  // 管理员审核数据
  adminBx = [];
  adminBxLoading = false;
  adminBxError = null;
  adminPagination = {
    page: 1,
    pageSize: 25,
    total: 0,
    totalPages: 0
  };

  constructor() {
    makeAutoObservable(this);

    const saved = window.localStorage.getItem('auth');
    if (saved) {
      const data = JSON.parse(saved);
      this.authToken = data.token;
      this.currentUser = data.user;
      if (this.authToken) {
        axios.defaults.headers.common['X-Auth-Token'] = this.authToken;
      }
    }
  }

  setAuth(token, user) {
    this.authToken = token;
    this.currentUser = user;
    axios.defaults.headers.common['X-Auth-Token'] = token || '';
    if (token && user) {
      window.localStorage.setItem('auth', JSON.stringify({ token, user }));
    } else {
      window.localStorage.removeItem('auth');
    }
  }

  async login(username, password) {
    this.authLoading = true;
    this.authError = null;
    try {
      const res = await axios.post('/api/login', { username, password });
      runInAction(() => {
        this.setAuth(res.data.token, res.data.user);
        this.authLoading = false;
      });
    } catch (e) {
      runInAction(() => {
        this.authError = e?.response?.data?.message || '登录失败';
        this.authLoading = false;
      });
      throw e;
    }
  }

  logout() {
    this.setAuth(null, null);
  }

  // bx
  async fetchbx(view, filters = {}) {
    // view: 'mine' | 'all'
    this.bxLoading = true;
    this.bxError = null;
    try {
      const res = await axios.get('/api/bx', { params: { view, ...filters } });
      runInAction(() => {
        if (res.data && res.data.data) {
          // 新的分页格式
          this.bx = res.data.data || [];
          const p = res.data.pagination || {};
          // 兼容后端 snake_case 与 camelCase
          this.pagination = {
            page: p.page ?? 1,
            pageSize: (p.page_size ?? p.pageSize) ?? 25,
            total: p.total ?? 0,
            totalPages: (p.total_pages ?? p.totalPages) ?? 0,
          };
        } else {
          // 兼容旧格式
          this.bx = res.data || [];
          this.pagination = {
            page: 1,
            pageSize: 25,
            total: this.bx.length,
            totalPages: 1
          };
        }
        this.bxLoading = false;
      });
    } catch (e) {
      runInAction(() => {
        this.bxError = e?.response?.data?.message || '获取失败';
        this.bxLoading = false;
      });
    }
  }

  // 管理员获取所有报销数据
  async fetchAdminBx(filters = {}) {
    this.adminBxLoading = true;
    this.adminBxError = null;
    try {
      const res = await axios.get('/api/bx', { params: { view: 'all', ...filters } });
      runInAction(() => {
        if (res.data && res.data.data) {
          // 新的分页格式
          this.adminBx = res.data.data || [];
          const p = res.data.pagination || {};
          // 兼容后端 snake_case 与 camelCase
          this.adminPagination = {
            page: p.page ?? 1,
            pageSize: (p.page_size ?? p.pageSize) ?? 25,
            total: p.total ?? 0,
            totalPages: (p.total_pages ?? p.totalPages) ?? 0,
          };
        } else {
          // 兼容旧格式
          this.adminBx = res.data || [];
          this.adminPagination = {
            page: 1,
            pageSize: 25,
            total: this.adminBx.length,
            totalPages: 1
          };
        }
        this.adminBxLoading = false;
      });
    } catch (e) {
      runInAction(() => {
        this.adminBxError = e?.response?.data?.message || '获取失败';
        this.adminBxLoading = false;
      });
    }
  }

  async submitBX(payload) {
    // The payload already uses snake_case for new fields
    const body = { ...payload };
    await axios.post('/api/bx', body);
    // 如果是管理员，同时刷新审核数据
    if (this.currentUser && this.currentUser.role === 'admin') {
      this.fetchAdminBx();
    }
  }

  async reviewBX(id, action, comment) {
    await axios.put(`/api/bx/${id}/review`, { action, comment });
  }

  async uploadAttachment(file) {
    const form = new FormData();
    form.append('file', file);
    const res = await axios.post('/api/upload', form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return res.data; // { filename, url }
  }

  async updateBX(id, payload) {
    const body = { ...payload };
    await axios.put(`/api/bx/${id}`, body);
    // 如果是管理员，同时刷新审核数据
    if (this.currentUser && this.currentUser.role === 'admin') {
      this.fetchAdminBx();
    }
  }
}

const store = new RootStore();
export default store;


